/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BbsContentInfoRespVo
 */
export interface BbsContentInfoRespVo {
    /**
     * 主键 ID
     * @type {number}
     * @memberof BbsContentInfoRespVo
     */
    id?: number;
    /**
     * 韩文名字
     * @type {string}
     * @memberof BbsContentInfoRespVo
     */
    nameKr?: string;
    /**
     * 中文名字
     * @type {string}
     * @memberof BbsContentInfoRespVo
     */
    nameCn?: string;
    /**
     * 韩文内容
     * @type {string}
     * @memberof BbsContentInfoRespVo
     */
    contentKr?: string;
    /**
     * 中文内容
     * @type {string}
     * @memberof BbsContentInfoRespVo
     */
    contentCn?: string;
    /**
     * 分类 ID，关联 BBS 分类表
     * @type {number}
     * @memberof BbsContentInfoRespVo
     */
    categoryId?: number;
    /**
     * 分类名称(中)
     * @type {string}
     * @memberof BbsContentInfoRespVo
     */
    categoryCnName?: string;
    /**
     * 分类名称(韩)
     * @type {string}
     * @memberof BbsContentInfoRespVo
     */
    categoryKrName?: string;
    /**
     * 是否可用：0-不可用，1-可用
     * @type {number}
     * @memberof BbsContentInfoRespVo
     */
    enable?: number;
    /**
     * 创建时间
     * @type {string}
     * @memberof BbsContentInfoRespVo
     */
    createTime?: string;
    /**
     * 修改时间
     * @type {string}
     * @memberof BbsContentInfoRespVo
     */
    updateTime?: string;
    /**
     * 员工id
     * @type {number}
     * @memberof BbsContentInfoRespVo
     */
    staffId?: number;
    /**
     * 员工名称
     * @type {string}
     * @memberof BbsContentInfoRespVo
     */
    staffName?: string;
    /**
     * 是否置顶， 0 不置顶， 1 置顶
     * @type {number}
     * @memberof BbsContentInfoRespVo
     */
    top?: number;
    /**
     * 排序序号：置顶优先，同置顶/非置顶内按序号升序，序号相同按发布时间倒序
     * @type {number}
     * @memberof BbsContentInfoRespVo
     */
    sort?: number;
    /**
     * 作者(中文)
     * @type {string}
     * @memberof BbsContentInfoRespVo
     */
    authorCn?: string;
    /**
     * 作者(韩文)
     * @type {string}
     * @memberof BbsContentInfoRespVo
     */
    authorKr?: string;
    /**
     * 发布时间
     * @type {string}
     * @memberof BbsContentInfoRespVo
     */
    publishTime?: string;
}

/**
 * Check if a given object implements the BbsContentInfoRespVo interface.
 */
export function instanceOfBbsContentInfoRespVo(value: object): value is BbsContentInfoRespVo {
    return true;
}

export function BbsContentInfoRespVoFromJSON(json: any): BbsContentInfoRespVo {
    return BbsContentInfoRespVoFromJSONTyped(json, false);
}

export function BbsContentInfoRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BbsContentInfoRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'nameKr': json['nameKr'] == null ? undefined : json['nameKr'],
        'nameCn': json['nameCn'] == null ? undefined : json['nameCn'],
        'contentKr': json['contentKr'] == null ? undefined : json['contentKr'],
        'contentCn': json['contentCn'] == null ? undefined : json['contentCn'],
        'categoryId': json['categoryId'] == null ? undefined : json['categoryId'],
        'categoryCnName': json['categoryCnName'] == null ? undefined : json['categoryCnName'],
        'categoryKrName': json['categoryKrName'] == null ? undefined : json['categoryKrName'],
        'enable': json['enable'] == null ? undefined : json['enable'],
        'createTime': json['createTime'] == null ? undefined : json['createTime'],
        'updateTime': json['updateTime'] == null ? undefined : json['updateTime'],
        'staffId': json['staffId'] == null ? undefined : json['staffId'],
        'staffName': json['staffName'] == null ? undefined : json['staffName'],
        'top': json['top'] == null ? undefined : json['top'],
        'sort': json['sort'] == null ? undefined : json['sort'],
        'authorCn': json['authorCn'] == null ? undefined : json['authorCn'],
        'authorKr': json['authorKr'] == null ? undefined : json['authorKr'],
        'publishTime': json['publishTime'] == null ? undefined : json['publishTime'],
    };
}

export function BbsContentInfoRespVoToJSON(json: any): BbsContentInfoRespVo {
    return BbsContentInfoRespVoToJSONTyped(json, false);
}

export function BbsContentInfoRespVoToJSONTyped(value?: BbsContentInfoRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'nameKr': value['nameKr'],
        'nameCn': value['nameCn'],
        'contentKr': value['contentKr'],
        'contentCn': value['contentCn'],
        'categoryId': value['categoryId'],
        'categoryCnName': value['categoryCnName'],
        'categoryKrName': value['categoryKrName'],
        'enable': value['enable'],
        'createTime': value['createTime'],
        'updateTime': value['updateTime'],
        'staffId': value['staffId'],
        'staffName': value['staffName'],
        'top': value['top'],
        'sort': value['sort'],
        'authorCn': value['authorCn'],
        'authorKr': value['authorKr'],
        'publishTime': value['publishTime'],
    };
}

